/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import bindLogger from 'helpers/BindLogger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { ATCONSTANTS as ATC } from 'appconstants';
import SiteIButton from 'components/iButton/SiteIButton';
import ProtocolIButton from 'components/iButton/ProtocolIButton';

export const SITE_CTEP_ID_NAME_MAP = {};
export const VALIDATED_PROTOCOL_NUMBER_MAP = {};

export const getSiteName = (siteCtepId) => SITE_CTEP_ID_NAME_MAP[siteCtepId];

export const isProtocolNumberValid = (num) => VALIDATED_PROTOCOL_NUMBER_MAP[num];

export const fetchData = (context, getAutoCompleteAction, isInstitution, searchText) => {
  const getOptions = (response) => response.map((r) => {
    if (isInstitution) {
      const { siteCtepId, siteName } = r;
      return {
        label: `${siteCtepId} - ${siteName}`,
        value: siteCtepId,
        siteName
      };
    }
    return {
      label: r,
      value: r
    };
  });
  return bindLogger(
    getAutoCompleteAction,
    context
  )(searchText).pipe(
    map((resp) => {
      const { response } = resp;
      if (response != null && response.length > 0) {
        return getOptions(response);
      }
      return [];
    })
  );
};

export const COLUMNS = [
  {
    label: 'Institution CTEP ID',
    name: 'siteCtepId',
    renderCell: (data) => (
      <>
        {data.siteCtepId}
        &nbsp;
        <SiteIButton siteCtepId={data.siteCtepId} />
      </>
    )
  },
  { label: 'Institution Name', name: 'siteName', className: 'gridcell-text-wrap' },
  {
    label: 'Protocol',
    name: 'protocolNumber',
    renderCell: (row) => (row.protocolNumber ? (
      <>
        {row.protocolNumber}
        {' '}
        &nbsp;
        <ProtocolIButton protocolNumber={row.protocolNumber} />
      </>
    ) : null)
  },
  {
    label: '',
    name: 'delete',
    sort: false,
    renderCell: (row, events) => {
      const onClick = () => {
        events[0](row);
      };
      return (
        <button
          data-id={`${ATC.PACKETID}${row.id}_DELETE_INSTITUTION${ATC.BUTTON}`}
          type="button"
          className="fn-btn delete turquoise"
          onClick={onClick}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </button>
      );
    }
  }
];

const fillProtocolMap = (context, protocolData, api) => {
  const fillData = (result, num) => {
    let valueData = null;
    if (result.length > 0) {
      result.some((item) => {
        const { value } = item;
        if (num === value) {
          VALIDATED_PROTOCOL_NUMBER_MAP[value] = true;
          valueData = value;
        }
        return num === value;
      });
    }
    return valueData;
  };
  const joins = {};
  protocolData.forEach((num) => {
    const searchText = num.toString().trim();
    if (searchText.length > 0 && !VALIDATED_PROTOCOL_NUMBER_MAP[searchText]) {
      joins[searchText] = fetchData(context, api, false, searchText).pipe(map((res) => fillData(res, searchText)));
    }
  });
  if (Object.keys(joins).length > 0) {
    return joins;
  }
  return {};
};

const fillSiteMap = (context, institutionalData, api) => {
  const fillData = (result, siteCtepID) => {
    let siteNameVal = null;
    if (result.length > 0) {
      result.some((item) => {
        const { siteName, value } = item;
        if (siteCtepID === value) {
          SITE_CTEP_ID_NAME_MAP[siteCtepID] = siteName;
          siteNameVal = siteName;
        }
        return siteCtepID === value;
      });
    }
    return siteNameVal;
  };
  const joins = {};
  institutionalData.forEach((siteCtepId) => {
    const searchText = siteCtepId.toUpperCase().trim();
    if (searchText.length > 0 && SITE_CTEP_ID_NAME_MAP[searchText] == null) {
      joins[searchText] = fetchData(context, api, true, searchText).pipe(map((res) => fillData(res, searchText)));
    }
  });
  if (Object.keys(joins).length > 0) {
    return joins;
  }
  return {};
};

export const fillValidMapValues = (context, institutionalData, protocolData, institutionAPI, protocolApi) => {
  const siteJoins = fillSiteMap(context, institutionalData, institutionAPI);
  const protocolJoins = fillProtocolMap(context, protocolData, protocolApi);
  const joins = { ...siteJoins, ...protocolJoins };
  if (Object.keys(joins).length > 0) {
    return forkJoin(joins);
  }
  return null;
};

export const getRowIndex = (row, rows) => rows.findIndex((r) => r.protocolNumber === row.protocolNumber && r.siteCtepId === row.siteCtepId);
